package ru.it_mozaika.sender.js.application.frames.templates

import js.core.jso
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import mui.material.*
import mui.material.styles.TypographyVariant
import mui.system.responsive
import mui.system.sx
import react.*
import react.dom.html.ReactHTML
import react.dom.onChange
import react.router.useNavigate
import ru.it_mozaika.components.*
import ru.it_mozaika.sender.common.models.EmailTemplateData
import ru.it_mozaika.sender.common.models.ColumnsFilter
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.sender.js.application.components.StoresSelect
import ru.it_mozaika.components.commonTableSkeletonFrame
import ru.it_mozaika.sender.common.models.EmailTemplate
import ru.it_mozaika.sender.common.models.TemplateType
import ru.it_mozaika.sender.js.application.context.RequestResultContext
import ru.it_mozaika.sender.js.application.context.useBackdrop
import ru.it_mozaika.sender.js.application.context.useStore
import ru.it_mozaika.sender.js.application.context.useTemplate
import ru.it_mozaika.sender.js.application.convertIntoLocalFormat
import ru.it_mozaika.sender.js.application.frames.MainCard
import tanstack.react.table.useReactTable
import tanstack.table.core.*
import web.cssom.*
import web.window.window

private enum class Columns(val ruTitle: String){
    ID("ID"),
    Title("Наименование"),
    Date("Дата изменения"),
}

val templatesListFrame = VFC {
    val storeContext = useStore()
    val currentStore = useMemo(storeContext.currentStore?.id){storeContext.currentStore}
    val templateContext = useTemplate()
    val templates = templateContext.templates
    val type = templateContext.currentType
    val (checkedProperties, setCheckedProperties) = useState(listOf<String>())
    val (propertiesFilter, setPropertiesFilter) = useState<List<ColumnsFilter>>(listOf())
    val (selectedTemplates, setSelectedTemplates) = useState<List<EmailTemplateData>>(listOf())
    var openEditDialog by useState(false)
    var openDeleteDialog by useState(false)

    val table = useReactTable<EmailTemplateData>(
        options = jso {
            columns = Columns.entries.map { column ->
                jso<ColumnDef<EmailTemplateData, Any?>> {
                    accessorFn = { temp, _ ->
                        when (column) {
                            Columns.ID -> temp.id
                            Columns.Title -> temp.name
                            Columns.Date -> temp.updateTime.toLocalDateTime(TimeZone.UTC).date.toString().convertIntoLocalFormat()
                        }
                    }
                    cell = ColumnDefTemplate { context ->
                        val value = context.getValue().toString()
                        when(column){
                            Columns.ID,
                            Columns.Title,
                            Columns.Date -> {
                                Box.create {
                                    + value
                                }
                            }
                        }
                    }
                    id = column.name
                    header = StringOrTemplateHeader(column.ruTitle)
                }
            }.toTypedArray()
                .plus(
                    jso<ColumnDef<EmailTemplateData, Any?>> {
                        header = StringOrTemplateHeader("Действия")
                        cell = ColumnDefTemplate { context ->
                            val id = context.row.getValue("ID").toString()
                            Stack.create {
                                sx {
                                    alignItems = AlignItems.center
                                }
                                spacing = responsive(2)
                                direction = responsive(StackDirection.row)
                                AvatarButton {
                                    tooltipTitle = "Редактирование"
                                    mui.icons.material.EditSharp {
                                        color = SvgIconColor.secondary
                                    }
                                    onClick = {
                                        templateContext.setCurrentTemplate(id)
                                        openEditDialog = true
                                    }
                                }
                                AvatarButton {
                                    tooltipTitle = "Удаление"
                                    mui.icons.material.DeleteSharp {
                                        color = SvgIconColor.error
                                    }
                                    onClick = {
                                        templateContext.setCurrentTemplate(id)
                                        openDeleteDialog = true
                                    }
                                }
                               when(type) {
                                   TemplateType.Unsubscribe -> {
                                       if(id == currentStore?.unsubscribePageId) Tooltip{
                                           title = ReactNode("Выбран как основной в магазине")
                                           mui.icons.material.CheckCircleSharp {
                                               color = SvgIconColor.secondary
                                           }
                                       }
                                   }
                                   TemplateType.Confirm -> {
                                       if(id == currentStore?.confirmationPageId) Tooltip{
                                           title = ReactNode("Выбран как основной в магазине")
                                           mui.icons.material.CheckCircleSharp {
                                               color = SvgIconColor.secondary
                                           }
                                       }
                                   }
                                   TemplateType.Review -> {
                                       if(id == currentStore?.reviewTemplateId) Tooltip{
                                           title = ReactNode("Выбран как основной в магазине")
                                           mui.icons.material.CheckCircleSharp {
                                               color = SvgIconColor.secondary
                                               +"Основной"
                                           }
                                       }
                                   }
                                   TemplateType.Campaign ,
                                   TemplateType.EmailTemplate,
                                   TemplateType.Trigger,
                                   null -> {}
                               }
                            }
                        }
                        id = "actions"
                    }
                )
            this.data = useMemo(templates) { templates.toTypedArray() }
            this.getCoreRowModel = getCoreRowModel()
            this.debugTable = true
            this.debugHeaders = true
            this.debugColumns = true
        }
    )
    editDialog{
        isOpen = openEditDialog
        onClose = {
            templateContext.clearCurrentTemplate()
            templateContext.reloadData()
            openEditDialog = false
        }
    }
    deleteDialog{
        isOpen = openDeleteDialog
        onClose = {
            templateContext.clearCurrentTemplate()
            templateContext.reloadData()
            openDeleteDialog = false
        }
    }
    MainCard {
        CardHeader {
            title = Stack.create {
                direction = responsive(StackDirection.row)
                spacing = responsive(5)
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexStart
                }
                Typography {
                    variant = TypographyVariant.h2
                    + type?.ruTitle
                }
                StoresSelect()
            }
            action = Stack.create {
                this.direction = responsive(StackDirection.row)
                this.divider = Divider.create {
                    orientation = Orientation.vertical
                }
                asDynamic().spacing = 2
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexStart
                }
                AvatarButton {
                    onClick = {
                        openEditDialog = true
                    }
                    tooltipTitle = "Создать"
                    mui.icons.material.AddCircleOutlineSharp()
                }
                Button{
                    variant = ButtonVariant.contained
                    color = ButtonColor.secondary
                    + "API документация"
                    onClick = {
                        window.open("${kotlinx.browser.window.location.origin}/api/v1/swagger/templates")
                    }
                }
            }
        }
        commonTableSkeletonFrame {
            showCheckBox = false
            currentSelected = selectedTemplates.map { it.id }
            toolbarActions = Stack.create {
                this.direction = responsive(StackDirection.row)
                this.divider = Divider.create {
                    orientation = Orientation.vertical
                }
                asDynamic().spacing = 2
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexStart
                }
                if (checkedProperties.isNotEmpty()) {
                    filterOffButton {
                        this.propertiesFilter = checkedProperties
                        this.handleOnFilterOffClick = {
                            setCheckedProperties(listOf())
                            setPropertiesFilter(listOf())
                        }
                    }
                }
            }
            this.label = "templates-list"
            this.propertiesFilter = propertiesFilter
            this.columnId = "ID"
            this.table = table
            this.onDoubleClickHandler = { id ->
                templateContext.setCurrentTemplate(id)
                openEditDialog = true
            }
            this.onPropertySelect = {}
            this.onSelectionChanged = { newSelected ->
                val newList = newSelected.mapNotNull { id ->
                    templates.associateBy { it.id }[id]
                }
                setSelectedTemplates(newList)
            }
        }
    }
}

private external interface EditDialogProps: Props {
    var isOpen: Boolean?
    var onClose: () -> Unit
}

private val editDialog = FC<EditDialogProps> { props ->
    var name by useState<String>()
    val storeContext = useStore()
    var content by useState<EmailTemplate>(EmailTemplate.Freemarker())
    val requestResult = useContext(RequestResultContext)
    var openConfirmDialog by useState(false)
    val templateContext = useTemplate()
    val currentTemplate = useMemo(templateContext.currentTemplate){templateContext.currentTemplate}
    val type = useMemo(templateContext.currentType){templateContext.currentType}
    var favicon by useState("")
    var showChangeMainTemplateDialog by useState(false)
    val backdrop = useBackdrop()
    val isMainTemplate = useMemo(when(currentTemplate?.type){
        null,
        TemplateType.Campaign,
        TemplateType.EmailTemplate,
        TemplateType.Trigger -> false
        TemplateType.Unsubscribe -> storeContext.currentStore?.unsubscribePageId
        TemplateType.Confirm -> storeContext.currentStore?.confirmationPageId
        TemplateType.Review -> storeContext.currentStore?.reviewTemplateId
    }) {
        when (currentTemplate?.type) {
            null,
            TemplateType.Campaign,
            TemplateType.EmailTemplate,
            TemplateType.Trigger -> false
            TemplateType.Unsubscribe -> storeContext.currentStore?.unsubscribePageId
            TemplateType.Confirm -> storeContext.currentStore?.confirmationPageId
            TemplateType.Review -> storeContext.currentStore?.reviewTemplateId
        } == currentTemplate?.id
    }

    useEffect(currentTemplate?.id) {
        name = currentTemplate?.name
        favicon = currentTemplate?.favicon ?: ""
    }
    useEffect(currentTemplate?.id) {
        content = currentTemplate?.template ?: EmailTemplate.Freemarker()
    }
    confirmDialog {
        isOpen = openConfirmDialog
        onClose = {
            openConfirmDialog = false
        }
        onConfirm = {
            content =
                if (content is EmailTemplate.Freemarker) EmailTemplate.BlockEditor() else EmailTemplate.Freemarker()
        }

    }
    mainTemplateConfirmDialog{
        isOpen = showChangeMainTemplateDialog
        onClose = {
            showChangeMainTemplateDialog = false
        }
    }
    Dialog {
        open = props.isOpen ?: false
        DialogTitle {
            +if (currentTemplate == null) "Добавление страницы" else "Редактирование страницы"
        }
        DialogContent {
            Stack {
                direction = responsive(StackDirection.column)
                spacing = responsive(2)
                sx {
                    padding = 5.px
                }
                TextField {
                    id = "new-name-field"
                    label = ReactNode("Наименование:")
                    this.variant = FormControlVariant.outlined
                    required = true
                    error = name.isNullOrBlank()
                    value = name ?: ""
                    this.onChange = { event ->
                        val value = event.target.asDynamic().value as String
                        name = value
                    }
                }
                if (currentTemplate?.type == TemplateType.Unsubscribe || type == TemplateType.Unsubscribe) {
                    TextField {
                        id = "new-favicon-field"
                        label = ReactNode("Ссылка на изображение:")
                        this.variant = FormControlVariant.outlined
                        required = true
                        value = favicon
                        this.onChange = { event ->
                            val value = event.target.asDynamic().value as String
                            favicon = value
                        }
                    }
                }
                if (currentTemplate?.type != TemplateType.Unsubscribe && type != TemplateType.Unsubscribe) {
                    Stack {
                        sx {
                            alignItems = AlignItems.center
                        }
                        direction = responsive(StackDirection.row)
                        Typography {
                            variant =
                                if (content is EmailTemplate.Freemarker) TypographyVariant.h5 else TypographyVariant.body1
                            +"HTML редактор"
                        }
                        Switch {
                            checked = content is EmailTemplate.BlockEditor
                            onChange = { _, _ ->
                                openConfirmDialog = true
                            }
                        }
                        Typography {
                            variant =
                                if (content is EmailTemplate.BlockEditor) TypographyVariant.h5 else TypographyVariant.body1
                            +"Блочный редактор"
                        }
                    }
                }
              when(type){
                  null,
                  TemplateType.Campaign,
                  TemplateType.EmailTemplate,
                  TemplateType.Trigger -> {}
                  TemplateType.Unsubscribe,
                  TemplateType.Confirm,
                  TemplateType.Review ->   FormControlLabel{
                      label = ReactNode("Основной")
                      control =  Checkbox.create {
                          color = CheckboxColor.secondary
                          checked =  isMainTemplate
                          onChange = { _, _ ->
                              showChangeMainTemplateDialog = true
                          }
                      }
                  }
              }
            }
        }
        DialogActions {
            sx {
                alignItems = AlignItems.center
            }
            Stack {
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                if (currentTemplate != null) Button {
                    variant = ButtonVariant.outlined
                    startIcon = mui.icons.material.EditSharp.create()
                    color = ButtonColor.success
                    +"Редактировать шаблон"
                    asDynamic().component = ReactHTML.a
                    asDynamic().href = "/editor/email?type=${currentTemplate.type.urlTitle}&id=${currentTemplate.id}"
                }
                Button {
                    variant = ButtonVariant.outlined
                    this.color = ButtonColor.secondary
                    +if (currentTemplate == null) "Добавить" else "Сохранить изменения"
                    this.disabled =
                        name.isNullOrBlank() || (currentTemplate?.template == content && currentTemplate.name == name)
                    this.onClick = {
                        backdrop.show()
                        if (currentTemplate == null && type != null) {
                            Http.put(
                                "/templates",
                                body = EmailTemplateData(
                                    id = "",
                                    store = storeContext.currentStoreId ?: "",
                                    name = name ?: "",
                                    template = content,
                                    favicon = favicon,
                                    type = type
                                ),
                                callback = { response ->
                                    requestResult.handleRequestRespond(response)
                                    backdrop.hide()
                                }
                            )
                        } else {
                            Http.post(
                                "/templates/item/update",
                                body = currentTemplate!!.copy(name = name ?: "", template = content, favicon = favicon),
                                callback = { response ->
                                    requestResult.handleRequestRespond(response)
                                    backdrop.hide()
                                }
                            )
                        }
                        props.onClose()
                    }
                }
                Button {
                    +"Отмена"
                    color = ButtonColor.error
                    variant = ButtonVariant.outlined
                    onClick = {
                        props.onClose()
                    }
                }
            }
        }
    }
}

private external interface ConfirmDialogProps:Props{
    var isOpen: Boolean?
    var onClose: () -> Unit
    var onConfirm: () -> Unit
}

private val confirmDialog = FC<ConfirmDialogProps> { props ->
    Dialog {
        open = props.isOpen ?: false
        DialogTitle {
            + "Внимание! Смена типа редактора приведет к удалению всех внесенных изменений в шаблон. Вы действительно хотите поменять редактор?"
        }
        DialogActions {
            sx {
                alignItems = AlignItems.center
                marginRight = 15.px
            }
            Stack {
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Button {
                    variant = ButtonVariant.outlined
                    this.color = ButtonColor.secondary
                    +"Да"
                    this.onClick = {
                        props.onConfirm()
                        props.onClose()
                    }
                }
                Button {
                    +"Отмена"
                    color = ButtonColor.error
                    variant = ButtonVariant.outlined
                    onClick = {
                        props.onClose()
                    }
                }
            }
        }
    }
}

private external interface DeleteDialogProps: Props{
    var isOpen: Boolean?
    var onClose: () -> Unit
}

private val deleteDialog = FC<DeleteDialogProps> { props ->
    val storeContext = useStore()
    val requestResult = useContext(RequestResultContext)
    val templateContext = useTemplate()
    val currentTemplate = useMemo(templateContext.currentTemplate?.id){templateContext.currentTemplate}
    val navigate = useNavigate()
    val backdrop = useBackdrop()
    val templateInUseCheck = useMemo(currentTemplate){
        when(currentTemplate?.type){
            TemplateType.EmailTemplate -> false
            TemplateType.Unsubscribe -> storeContext.storeList.find{it.id ==  currentTemplate.store}?.unsubscribePageId == currentTemplate.id
            TemplateType.Confirm -> storeContext.storeList.find{it.id ==  currentTemplate.store}?.confirmationPageId == currentTemplate.id
            TemplateType.Review -> storeContext.storeList.find{it.id ==  currentTemplate.store}?.reviewTemplateId == currentTemplate.id
            else -> null
        }
    }
    Dialog {
        open = props.isOpen ?: false
        DialogTitle {
            + if (templateInUseCheck == true) "Данный шаблон используется как основной!!" else  "Вы уверены что хотите удалить данный шаблон?"
        }

        if (templateInUseCheck == true) {
            DialogContent{
                Stack{
                    direction = responsive(StackDirection.column)
                    spacing = responsive(2)
                    sx{
                        alignItems = AlignItems.center
                    }
                    Typography {
                        +"Для удаления необходимо поменять используемый шаблон в магазине на вкладке \"Магазины\""
                    }
                    Button {
                        +"Перейти к магазинам"
                        variant = ButtonVariant.outlined
                        onClick = {
                            navigate("/stores")
                        }
                    }
                }
            }
        }
        DialogActions {
            sx {
                alignItems = AlignItems.center
                marginRight = 15.px
            }
            Stack {
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                if (templateInUseCheck == false){
                    Button {
                        variant = ButtonVariant.outlined
                        this.color = ButtonColor.secondary
                        +"Да"
                        this.onClick = {
                            backdrop.show()
                            currentTemplate?.id?.let {
                                Http.delete(
                                    "/templates/item",
                                    query = mapOf("id" to it),
                                    callback = { response ->
                                        requestResult.handleRequestRespond(response)
                                        backdrop.hide()
                                    }
                                )
                            }
                            props.onClose()
                        }
                    }
                }
                Button {
                    +"Отмена"
                    color = ButtonColor.error
                    variant = ButtonVariant.outlined
                    onClick = {
                        props.onClose()
                    }
                }
            }
        }
    }
}

private external interface MainTemplateConfirmDialogProps:Props{
    var isOpen: Boolean?
    var onClose: () -> Unit
}

private val mainTemplateConfirmDialog = FC<MainTemplateConfirmDialogProps> { props ->
    val storeContext = useStore()
    val templateContext = useTemplate()
    val requestResultContext = useContext(RequestResultContext)
    val navigate = useNavigate()
    val currentStore = storeContext.currentStore
    val currentTemplate = templateContext.currentTemplate
    val backdrop = useBackdrop()
    val templateInUseCheck = useMemo(currentTemplate){
        when(currentTemplate?.type){
            TemplateType.EmailTemplate -> false
            TemplateType.Unsubscribe -> storeContext.storeList.find{it.id ==  currentTemplate.store}?.unsubscribePageId == currentTemplate.id
            TemplateType.Confirm -> storeContext.storeList.find{it.id ==  currentTemplate.store}?.confirmationPageId == currentTemplate.id
            TemplateType.Review -> storeContext.storeList.find{it.id ==  currentTemplate.store}?.reviewTemplateId == currentTemplate.id
            else -> null
        }
    }

    Dialog {
        open = props.isOpen ?: false
        DialogTitle {
            + if (templateInUseCheck == true) "Данный шаблон выбран основным в магазине \"${currentStore?.name}\"" else "Вы уверены, что хотите установить данный шаблон основным?"
        }
        if (templateInUseCheck == true) {
            DialogContent{
                Stack{
                    direction = responsive(StackDirection.column)
                    spacing = responsive(2)
                    sx{
                        alignItems = AlignItems.center
                    }
                    Typography {
                        +"Необходимо поменять используемый шаблон в магазине на вкладке \"Магазины\""
                    }
                    Button {
                        +"Перейти к магазинам"
                        variant = ButtonVariant.outlined
                        onClick = {
                            navigate("/stores")
                        }
                    }
                }
            }
        }
        DialogActions {
            sx {
                alignItems = AlignItems.center
                marginRight = 15.px
            }
            Stack {
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Button {
                    variant = ButtonVariant.outlined
                    disabled = templateInUseCheck
                    this.color = ButtonColor.secondary
                    +"Да"
                    this.onClick = {
                        backdrop.show()
                        when (templateContext.currentType) {
                            TemplateType.Unsubscribe -> storeContext.currentStore?.copy(unsubscribePageId =  currentTemplate?.id)
                            TemplateType.Confirm -> storeContext.currentStore?.copy(confirmationPageId = currentTemplate?.id)
                            TemplateType.Review -> storeContext.currentStore?.copy(reviewTemplateId =  currentTemplate?.id)
                            TemplateType.Campaign,
                            TemplateType.EmailTemplate,
                            TemplateType.Trigger,
                            null -> null
                        }?.let { request ->
                            currentStore?.id?.let {id ->
                                Http.post(
                                    "/stores/$id",
                                    query = mapOf("store" to id),
                                    body = request
                                ) { response ->
                                    requestResultContext.handleRequestRespond(response)
                                    storeContext.updateStoreList()
                                    backdrop.hide()
                                }
                            }
                        }
                        props.onClose()
                    }
                }
                Button {
                    +"Отмена"
                    color = ButtonColor.error
                    variant = ButtonVariant.outlined
                    onClick = {
                        props.onClose()
                    }
                }
            }
        }
    }
}